// ---------------
// NOUVEAU FICHIER : src/pages/Terms.js (MIS À JOUR)
// ---------------
import React, { useState, useEffect } from 'react';

const Terms = () => {
    const [showScrollButton, setShowScrollButton] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowScrollButton(true);
            } else {
                setShowScrollButton(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            <section className="page-hero">
                <div className="page-hero-content">
                    <h1>Termes et Conditions Générales d'Utilisation</h1>
                    <p>Dernière mise à jour : 5 août 2025</p>
                </div>
            </section>

            <section className="legal-page-container">
                <p>
                    Les présentes conditions générales d'utilisation (dites « CGU ») ont pour objet l'encadrement juridique
                    des modalités de mise à disposition du site et des services par WONYA SOFT S.A et de définir
                    les conditions d’accès et d’utilisation des services par « l'Utilisateur ».
                </p>

                <article>
                    <h2>ARTICLE 1 : DÉFINITIONS</h2>
                    <p>
                        <strong>La Société :</strong> WONYA SOFT S.A, ayant son siège social au 6 Avenue Colonel Tshatshi, Commune Ruashi, Lubumbashi, RDC, immatriculée au Registre du Commerce et du Crédit Mobilier sous le numéro N° CD/LSH/RCCM/16-B-04061 et à l’Identification Nationale sous le numéro 05-F4300-N50778U.
                        <br />
                        <strong>Le Site :</strong> Le site internet accessible à l'URL https://wonyaso.com, ainsi que l'ensemble des sous-domaines et applications associés.
                        <br />
                        <strong>L'Utilisateur :</strong> Toute personne physique ou morale qui accède et navigue sur le Site, qu'elle soit simple visiteur ou client.
                        <br />
                        <strong>Les Services :</strong> L'ensemble des prestations proposées par la Société, incluant mais ne se limitant pas à la fourniture de l'application WonyaPay, l'accès à l'API Mobile Money, et le développement de logiciels sur mesure.
                    </p>
                </article>

                <article>
                    <h2>ARTICLE 2 : OBJET ET ACCEPTATION</h2>
                    <p>
                        Les présentes CGU régissent l'accès et l'utilisation du Site et des Services. Toute utilisation du Site implique l'acceptation sans réserve ni restriction des présentes CGU par l’Utilisateur. En cas de non-acceptation des CGU stipulées dans le présent contrat, l'Utilisateur se doit de renoncer à l'accès des services proposés par le site. WonyaSoft se réserve le droit de modifier unilatéralement et à tout moment le contenu des présentes CGU.
                    </p>
                </article>

                <article>
                    <h2>ARTICLE 3 : PROPRIÉTÉ INTELLECTUELLE</h2>
                    <p>
                        L'ensemble des éléments constituant le présent Site (textes, graphismes, logiciels, photographies, images, vidéos, sons, plans, noms, logos, marques, créations et œuvres protégeables diverses, bases de données, etc.) ainsi que le Site lui-même, relèvent des législations congolaises et internationales sur le droit d'auteur et sur les droits voisins.
                    </p>
                    <p>
                        Toute représentation ou reproduction, intégrale ou partielle, est systématiquement soumise à l’autorisation de la Société. Toute utilisation non autorisée du contenu est constitutive de contrefaçon et sanctionnée au titre du Code de la Propriété Intellectuelle.
                    </p>
                </article>

                <article>
                    <h2>ARTICLE 4 : ACCÈS ET UTILISATION DES SERVICES</h2>
                    <p>
                        L'accès au site est gratuit pour tout Utilisateur disposant d'un accès à Internet. Les coûts afférents à l'accès (matériel informatique, logiciels, connexion Internet, etc.) sont à la charge de l'Utilisateur.
                    </p>
                    <h3>4.1. API Mobile Money</h3>
                    <p>L'accès à l'API est conditionné par le paiement d'une licence annuelle. L'Utilisateur s'engage à utiliser l'API conformément à la documentation fournie et à ne pas tenter de contourner les mesures de sécurité.</p>
                    <h3>4.2. Logiciels sur Mesure</h3>
                    <p>Le développement de logiciels sur mesure fait l'objet d'un contrat spécifique entre la Société et le client, détaillant le cahier des charges, les délais, les modalités de paiement et de livraison.</p>
                </article>

                <article>
                    <h2>ARTICLE 5 : RESPONSABILITÉ</h2>
                    <p>
                        WonyaSoft met en œuvre tous les moyens raisonnables à sa disposition pour assurer un accès de qualité au Site et aux Services, mais n'est tenu à aucune obligation d'y parvenir. La Société ne peut, en outre, être tenue responsable de tout dysfonctionnement du réseau ou des serveurs ou de tout autre événement échappant au contrôle raisonnable, qui empêcherait ou dégraderait l'accès aux Services.
                    </p>
                    <p>
                        La responsabilité de WonyaSoft ne pourra être engagée qu'en cas de faute prouvée et exclusive dans l'exécution de ses obligations. En aucun cas, la Société ne sera tenue responsable des dommages indirects, tels que préjudice commercial, perte de clientèle, perte de commande, trouble commercial quelconque, perte de bénéfice ou d'image de marque.
                    </p>
                </article>

                <article>
                    <h2>ARTICLE 6 : PROTECTION DES DONNÉES PERSONNELLES</h2>
                    <p>
                        WonyaSoft s'engage à protéger les données à caractère personnel de ses Utilisateurs conformément à la législation en vigueur en République Démocratique du Congo, notamment la <strong>Loi n° 20/017 du 25 novembre 2020 relative aux télécommunications et aux technologies de l’information et de la communication</strong>.
                    </p>
                    <p>
                        Les données collectées (nom, adresse e-mail, numéro de téléphone, données de transaction, etc.) sont nécessaires à la fourniture des Services, à la gestion de la relation client et à la lutte contre la fraude et le blanchiment d'argent, conformément aux directives de la Banque Centrale du Congo (BCC).
                    </p>
                    <p>
                        Conformément à la loi, l'Utilisateur dispose d'un droit d'accès, de rectification, de suppression et d'opposition de ses données personnelles. Pour exercer ces droits, l'Utilisateur peut contacter notre Délégué à la Protection des Données à l'adresse : <a href="mailto:wonyasoft.sa@gmail.com">wonyasoft.sa@gmail.com</a>.
                    </p>
                </article>

                <article>
                    <h2>ARTICLE 7 : DROIT APPLICABLE ET JURIDICTION COMPÉTENTE</h2>
                    <p>
                        Les présentes CGU sont régies par le droit de la République Démocratique du Congo. Tout litige relatif à leur interprétation et/ou à leur exécution relève de la compétence exclusive des tribunaux de Lubumbashi, nonobstant pluralité de défendeurs ou appel en garantie.
                    </p>
                </article>

                <article>
                    <h2>ARTICLE 8 : TARIFICATION ET FRAIS DE SERVICE</h2>
                    <p>
                        <strong>8.1. Caractère Payant des Services :</strong> L'ensemble des services proposés par WONYA SOFT S.A, incluant l'accès à l'API Mobile Money, l'application WonyaPay, et le développement de logiciels sur mesure, sont des services payants. Les tarifs applicables sont communiqués sur le Site ou sur devis spécifique.
                    </p>
                    <h3>8.2. Mode Test et Frais de Service</h3>
                    <p>
                        Lors de la création d'un compte API, l'Utilisateur dispose d'un environnement de test permettant de simuler des transactions. Dans ce mode Test, <strong>l'argent traité par WONYA SOFT constitue des frais de service</strong> destinés à couvrir les coûts d'infrastructure, de maintenance et de support technique. Ces frais sont conservés par la Société en contrepartie de la mise à disposition de la plateforme de test.
                    </p>
                    <h3>8.3. Mode Production et Transit des Fonds</h3>
                    <p>
                        Une fois le compte API activé en mode Production, <strong>WONYA SOFT ne conserve aucun fonds appartenant à l'Utilisateur</strong>. La Société agit uniquement comme intermédiaire technique pour le traitement des transactions. Les fonds transitent directement vers les comptes désignés par l'Utilisateur, après déduction des frais de transaction applicables (clairement communiqués : 2% sur les transactions sortantes, 0% sur les transactions entrantes pour l'Utilisateur, 2% facturés aux payeurs).
                    </p>
                    <h3>8.4. Transparence Financière et Gestion des Fonds</h3>
                    <p>
                        L'Utilisateur reconnaît et accepte les conditions suivantes relatives à la gestion de ses flux financiers :
                    </p>
                    <ul style={{ marginLeft: '2rem', lineHeight: '1.8' }}>
                        <li><strong>Distinction des Modes :</strong> Les frais de service engagés en mode « Test » sont strictement destinés à l'environnement de simulation ; ils ne sont ni remboursables, ni transférables vers le mode « Production ».</li>
                        <li><strong>Modèle de Commission :</strong> En mode Production, la rémunération de WONYA SOFT se limite exclusivement aux frais de transaction (commissions) convenus. Aucun frais caché n'est appliqué sur les mouvements de fonds.</li>
                        <li><strong>Principe de Non-Rétention :</strong> Par principe, WONYA SOFT ne conserve jamais les fonds appartenant à ses Utilisateurs. Les fonds transitent via la plateforme pour être mis à disposition du bénéficiaire.</li>
                        <li><strong>Exception :</strong> Une rétention temporaire ou une gestion de compte peut être mise en place uniquement dans le cadre d'un Contrat de Prestation de Service spécifique, par lequel l'Utilisateur mandate expressément WONYA SOFT pour conserver ou administrer lesdits fonds.</li>
                        <li><strong>Disponibilité et Retraits :</strong> L'Utilisateur conserve un accès permanent à son historique transactionnel. Il peut initier le retrait de ses fonds disponibles à tout moment. WONYA SOFT s'engage à ne pratiquer aucune retenue, blocage ou appropriation injustifiée, sous réserve des délais de traitement bancaire et des vérifications de conformité (KYC/AML).</li>
                    </ul>
                    <h3>8.5. Paiements en Masse (Bulk Payments) et Points de Sortie</h3>
                    <p>
                        Pour les opérations de paiement groupés, des contraintes spécifiques s'appliquent pour garantir la sécurité du système :
                    </p>
                    <ul style={{ marginLeft: '2rem', lineHeight: '1.8' }}>
                        <li><strong>Provisionnement Préalable :</strong> Tout paiement en masse ne peut être exécuté que si le solde du compte Utilisateur est suffisant pour couvrir l'intégralité du montant principal ainsi que les frais de transaction y afférents.</li>
                        <li><strong>Limites de Transaction :</strong> Pour des raisons de sécurité, des plafonds journaliers ou par transaction peuvent être appliqués aux points de sortie. Toute augmentation de ces limites doit faire l'objet d'une validation écrite préalable.</li>
                        <li><strong>Responsabilité des Données :</strong> L'Utilisateur est seul responsable de l'exactitude des coordonnées des bénéficiaires (numéros de comptes, identifiants mobiles). Une fois l'ordre de paiement en masse validé et transmis au réseau bancaire ou mobile, l'opération est considérée comme irréversible.</li>
                        <li><strong>Suspension de Sortie :</strong> WONYA SOFT se réserve le droit de suspendre temporairement un point de sortie ou une demande de paiement en masse en cas de suspicion de fraude ou d'activité inhabituelle, afin de protéger les fonds de l'Utilisateur.</li>
                    </ul>
                </article>

                 <article>
                    <h2>ARTICLE 9 : CONTACT</h2>
                    <p>
                        Pour toute question relative aux présentes CGU, les Utilisateurs peuvent contacter la Société à l'adresse suivante : <a href="mailto:contact@wonyasoft.com">contact@wonyasoft.com</a> ou par courrier à l'adresse mentionnée à l'Article 1.
                    </p>
                </article>
            </section>

            <style>{`
                .scroll-to-top-btn {
                    position: fixed;
                    bottom: 2rem;
                    right: 2rem;
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%);
                    border: none;
                    color: white;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
                    transition: all 0.3s ease;
                    z-index: 999;
                }

                .scroll-to-top-btn:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 6px 16px rgba(102, 126, 234, 0.5);
                }

                .scroll-to-top-btn:active {
                    transform: translateY(-1px);
                }

                .scroll-to-top-btn svg {
                    width: 24px;
                    height: 24px;
                }

                @media (max-width: 768px) {
                    .scroll-to-top-btn {
                        bottom: 1.5rem;
                        right: 1.5rem;
                        width: 48px;
                        height: 48px;
                    }

                    .scroll-to-top-btn svg {
                        width: 24px;
                        height: 24px;
                    }
                }

                @media (max-width: 480px) {
                    .scroll-to-top-btn {
                        bottom: 1rem;
                        right: 1rem;
                        width: 45px;
                        height: 45px;
                    }

                    .scroll-to-top-btn svg {
                        width: 20px;
                        height: 20px;
                    }
                }
            `}</style>

            {/* Bouton Scroll to Top */}
            {showScrollButton && (
                <button 
                    onClick={scrollToTop} 
                    className="scroll-to-top-btn"
                    title="Remonter en haut"
                    aria-label="Remonter en haut de la page"
                >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="18 15 12 9 6 15"></polyline>
                    </svg>
                </button>
            )}
        </>
    );
};

export default Terms;
